import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import Addresses from "../../molecules/Addresses/Addresses";
import GeneralForm from "../../organisms/forms/GeneralForm/GeneralForm";
import DistributorForm from "../../organisms/forms/DistributorForm/DistributorForm";

const Contact = () => {
  return (
    <StyledContact>
      <Container>
        <UnderlinedHeader text={"Kontakt"} bolder />
        <Addresses />
        <Text>
          W przypadku pytań dotyczących części / produktów, współpracy proszę
          wypełnić poniższy formularz.
        </Text>
        <UnderlinedHeader text={"Zapytania ogólne"} />
        <GeneralForm />
        <UnderlinedHeader text={"Formularz zapytania dealera / dystrybutora"} />
        <DistributorForm />
      </Container>
    </StyledContact>
  );
};

export default Contact;

const StyledContact = styled.div`
  padding-top: 92px;
  font-family: "Open Sans", sans-serif;
  color: #666666;
`;

const Text = styled.p`
  font-size: 14px;
`;
